
import { useState, useEffect } from 'react';

interface AdminSidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

const AdminSidebar = ({ activeTab, setActiveTab, isCollapsed, setIsCollapsed }: AdminSidebarProps) => {
  const [expandedMenu, setExpandedMenu] = useState<string | null>('homepage');

  useEffect(() => {
    const menuItems = [
      {
        id: 'homepage',
        submenu: ['banners', 'sections', 'gallery', 'logo-favicon']
      },
      {
        id: 'about-menu',
        submenu: ['about-story', 'about-mission', 'about-values', 'about-brand', 'about-services']
      },
      {
        id: 'services-menu',
        submenu: ['services', 'section-items']
      },
      {
        id: 'news-menu',
        submenu: ['news-categories', 'news']
      }
    ];

    // Tìm menu cha của tab hiện tại
    const parentMenu = menuItems.find(menu => 
      menu.submenu.includes(activeTab)
    );

    if (parentMenu) {
      setExpandedMenu(parentMenu.id);
    } else if (activeTab === 'dashboard' || activeTab === 'contacts' || activeTab === 'seo-management' || activeTab === 'settings') {
      setExpandedMenu(null);
    }
  }, [activeTab]);

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Tổng quan',
      icon: 'ri-dashboard-line'
    },
    {
      id: 'homepage',
      label: 'Quản lý trang chủ',
      icon: 'ri-home-line',
      submenu: [
        { id: 'banners', label: 'Banner & Hero', icon: 'ri-image-line' },
        { id: 'sections', label: 'Các phần nội dung', icon: 'ri-layout-line' },
        { id: 'gallery', label: 'Thư viện ảnh', icon: 'ri-gallery-line' },
        { id: 'logo-favicon', label: 'Logo & Favicon', icon: 'ri-file-image-line' }
      ]
    },   
    {
      id: 'services-menu',
      label: 'Giải pháp và Dịch vụ',
      icon: 'ri-customer-service-line',
      submenu: [
        { id: 'services', label: 'Giải pháp và Dịch vụ', icon: 'ri-service-line' },
        { id: 'section-items', label: 'Nội dung Section', icon: 'ri-file-list-3-line' }
      ]
    },
    // {
    //   id: 'projects-menu', // Đã xóa module project
    //   label: 'Quản lý dự án',
    //   icon: 'ri-folder-line',
    //   submenu: [
    //     { id: 'project-categories', label: 'Quản lý danh mục', icon: 'ri-folder-settings-line' },
    //     { id: 'projects', label: 'Quản lý dự án', icon: 'ri-folder-line' }
    //   ]
    // },
    {
      id: 'news-menu',
      label: 'Quản lý tin tức',
      icon: 'ri-article-line',
      submenu: [
        { id: 'news-categories', label: 'Quản lý danh mục', icon: 'ri-price-tag-3-line' },
        { id: 'news', label: 'Quản lý tin tức', icon: 'ri-article-line' }
      ]
    },
    // {
    //   id: 'academy-menu', // Đã xóa module academy
    //   label: 'Quản lý Academy',
    //   icon: 'ri-graduation-cap-line',
    //   submenu: [
    //     { id: 'academy-projects', label: 'Quản lý đồ án', icon: 'ri-file-code-line' }
    //   ]
    // },
    {
      id: 'about-menu',
      label: 'Về chúng tôi',
      icon: 'ri-information-line',
      submenu: [
        { id: 'about-story', label: 'Câu chuyện', icon: 'ri-book-open-line' },
        { id: 'about-mission', label: 'Sứ mệnh & Tầm nhìn', icon: 'ri-compass-3-line' },
        { id: 'about-values', label: 'Giá trị cốt lõi', icon: 'ri-lightbulb-flash-line' },
        { id: 'about-brand', label: 'Nhận diện thương hiệu', icon: 'ri-palette-line' },
        { id: 'about-services', label: 'Ba lĩnh vực cốt lõi', icon: 'ri-service-line' }
      ]
    },
    {
      id: 'contacts',
      label: 'Quản lý liên hệ',
      icon: 'ri-mail-line'
    },
    {
      id: 'seo-management',
      label: 'Quản lý SEO',
      icon: 'ri-search-line'
    },
    {
      id: 'settings',
      label: 'Cài đặt',
      icon: 'ri-settings-line'
    }
  ];

  const handleMenuClick = (itemId: string, hasSubmenu: boolean) => {
    if (hasSubmenu) {
      setExpandedMenu(expandedMenu === itemId ? null : itemId);
    } else {
      setActiveTab(itemId);
      setExpandedMenu(null);
    }
  };

  const handleSubmenuClick = (submenuId: string) => {
    setActiveTab(submenuId);
  };

  return (
    <div className={`fixed left-0 top-0 h-full bg-[#2A4B7C] text-white transition-all duration-300 z-30 ${
      isCollapsed ? 'w-16' : 'w-64'
    }`}>
      {/* Toggle Button */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-6 w-6 h-6 bg-[#2A4B7C] border-2 border-white rounded-full flex items-center justify-center hover:bg-[#1e3a5f] transition-colors"
      >
        <i className={`ri-arrow-${isCollapsed ? 'right' : 'left'}-s-line text-xs text-white`}></i>
      </button>

      {/* Logo */}
      <div className="p-4 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#00C897] rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-admin-line text-white text-lg"></i>
          </div>
          {!isCollapsed && (
            <div>
              <h2 className="font-bold text-lg">Admin Panel</h2>
              <p className="text-xs text-white/70">StackWay</p>
            </div>
          )}
        </div>
      </div>

      {/* Menu Items */}
      <nav className="mt-6">
        {menuItems.map((item) => (
          <div key={item.id}>
            <button
              onClick={() => handleMenuClick(item.id, !!item.submenu)}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-white/10 transition-colors ${
                activeTab === item.id || 
                (item.submenu && item.submenu.some(sub => sub.id === activeTab)) ||
                (item.id === 'settings' && activeTab.startsWith('settings-'))
                  ? 'bg-white/20 border-r-2 border-[#00C897]' 
                  : ''
              }`}
              title={isCollapsed ? item.label : undefined}
            >
              <i className={`${item.icon} text-xl flex-shrink-0`}></i>
              {!isCollapsed && (
                <>
                  <span className="font-medium flex-1">{item.label}</span>
                  {item.submenu && (
                    <i className={`ri-arrow-${expandedMenu === item.id ? 'up' : 'down'}-s-line text-sm`}></i>
                  )}
                </>
              )}
            </button>
            
            {/* Submenu */}
            {item.submenu && expandedMenu === item.id && !isCollapsed && (
              <div className="bg-white/5">
                {item.submenu.map((subItem) => (
                  <button
                    key={subItem.id}
                    onClick={() => handleSubmenuClick(subItem.id)}
                    className={`w-full flex items-center gap-3 px-8 py-2 text-left hover:bg-white/10 transition-colors ${
                      activeTab === subItem.id ? 'bg-white/20 text-[#00C897]' : ''
                    }`}
                  >
                    <i className={`${subItem.icon} text-lg flex-shrink-0`}></i>
                    <span className="text-sm">{subItem.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Back to Website */}
      <div className="absolute bottom-4 left-0 right-0 px-4">
        <a
          href="/"
          className="flex items-center gap-3 px-4 py-3 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
        >
          <i className="ri-arrow-left-line text-xl flex-shrink-0"></i>
          {!isCollapsed && <span>Về trang chủ</span>}
        </a>
      </div>
    </div>
  );
};

export default AdminSidebar;
